import React from 'react';

class Loader extends React.Component {
    render() {

        if(this.props.show) {
            return(
                <div className="loader"></div>
            );
        } else {
            return(
                <div/>
            );
        }
    }
}

export default Loader;